import React, { useState, useEffect, memo } from "react";
import { Tabs, Tab, Box, Paper } from "@mui/material";
import FollowUp from "./components/followUp";
import Speed from "./components/speed";
import HttpClient from "../../helpers/HttpClient";
import { useSelector } from "react-redux";
import { showToast } from "../../utils/toast";
import OverlayLoader from "../OverlayLoader";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

function ProgressModal({ open }) {
    const [value, setValue] = useState(0);
    const authState = useSelector((state) => state.auth);
    const [openLoader, setOpenOpenLoader] = useState(false);
    const userId = authState && authState.user ? authState.user.email : "test";

    const [rowsTable, setRowsTable] = useState([]);
    const [velocity, setVelocity] = useState([]);
    const [comprehension, setComprehension] = useState([]);
    const [perfectWeeks, setPerfectWeeks] = useState(0)
    const [currentDay, setCurrentDay] = useState(0)

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const processDataProgress = (data) => {
        let rowsTableTemp: any = [];
        let counterTest = 0;
        const arVelocityTemp = [];
        const arComprenhesionTemp = [];
        let perfectWeeksTemp = 0
        let currentDayTemp = 0
        for (let i = 0; i < data.length; i++) {
            let isWeek = false
            let numTestByLesson = 0 
            let numTestByLessonResolved = 0
            let numSublessons = 0
            let numSublessonsResolved = 0
            const lessons = data[i].lessons;
            if (lessons.length > 0) {
                let hasSublessons = false;
                const arObjectsToConcat = [];
                const unitNameParts = data[i].nombre.split(" ");
                for (let j = 0; j < lessons.length; j++) {

                    //lecciones sin subleccion
                    const sublessons = lessons[j].sublessons;

                    if (!sublessons || sublessons.length == 0) {
                        if (lessons[j].results && lessons[j].results.length > 0) {
                            const resultsData = lessons[j].results[0];
                            let obj = {
                                fecha: resultsData.ultima_fecha,
                                semana: "",
                                dia: "",
                                descripcion: lessons[j].nombre,
                                velocidad: "",
                            };

                            if (lessons[j].tipo == "TEST") {
                                numTestByLesson++
                            }
                            
                            if (resultsData.meta) {
                                counterTest++;
                                const metadata = JSON.parse(
                                    resultsData.meta.replace(/\\"/g, '"')
                                );
                                obj.velocidad = metadata.velocity;
                                arVelocityTemp.push({ y: metadata.velocity, x: resultsData.ultima_fecha });
                                arComprenhesionTemp.push({ y: metadata.comprehension, x: resultsData.ultima_fecha });
                                if (!isNaN(unitNameParts[1])) {
                                    obj.semana = unitNameParts[1];
                                }
                                if (lessons[j].tipo == "TEST") {
                                    numTestByLessonResolved++
                                }
                            }

                            
                            
                            arObjectsToConcat.push(obj);
                        } else {
                            rowsTableTemp.push({
                                fecha: "",
                                semana: "",
                                dia: "",
                                descripcion: lessons[j].nombre,
                                velocidad: "",
                            });
                        }
                    } else {
                        hasSublessons = true;
                        isWeek = true
                        //días, sesiones, ejericicos
                        arObjectsToConcat.push({
                            fecha: "",
                            semana: unitNameParts[1],
                            dia: lessons[j].nombre.split(" ")[1],
                            descripcion: lessons[j].nombre,
                            velocidad: "",
                        });

                        numSublessons += sublessons.length
                        for (let k = 0; k < sublessons.length; k++) {
                            const resultsDataS =
                                sublessons[k].results && sublessons[k].results.length > 0
                                    ? sublessons[k].results[0]
                                    : null;
                            let obj = {
                                fecha: resultsDataS ? resultsDataS.ultima_fecha : "",
                                semana: unitNameParts[1],
                                dia: lessons[j].nombre.split(" ")[1],
                                descripcion: sublessons[k].nombre,
                                velocidad: "",
                            };
                            if (resultsDataS.meta) {
                                const metadata = JSON.parse(
                                    resultsDataS.meta.replace(/\\"/g, '"')
                                );
                                obj.velocidad = metadata.velocity;
                                numSublessonsResolved++
                                currentDayTemp = lessons[j].nombre.split(" ")[1]

                            }
                            arObjectsToConcat.push(obj);
                        }
                    }
                }
                if (hasSublessons) {
                    rowsTableTemp.push({
                        fecha: "",
                        semana: unitNameParts[1],
                        dia: "",
                        descripcion: data[i].nombre,
                        velocidad: "",
                    });
                } else {
                    rowsTableTemp.push({
                        fecha: "",
                        semana: "",
                        dia: "",
                        descripcion: data[i].nombre,
                        velocidad: "",
                    });
                }
                rowsTableTemp = rowsTableTemp.concat(arObjectsToConcat);
            } else {
                rowsTableTemp.push({
                    fecha: "",
                    semana: "",
                    dia: "",
                    descripcion: data[i].nombre,
                    velocidad: "",
                });
            }

            if (isWeek && numSublessons == numSublessonsResolved && numTestByLesson == numTestByLessonResolved) {
                perfectWeeksTemp++
            }
        }
        setRowsTable(rowsTableTemp);

        if (counterTest > arVelocityTemp.length) {
            for (let m = 0; m < counterTest - arVelocityTemp.length; m++) {
                arVelocityTemp.push({ y: 0, x: '' });
            }
        }

        if (counterTest > arComprenhesionTemp.length) {
            for (let m = 0; m < counterTest - arComprenhesionTemp.length; m++) {
                arComprenhesionTemp.push({ y: 0, x: '' });
            }
        }

        setPerfectWeeks(perfectWeeksTemp)
        setVelocity(arVelocityTemp);
        setComprehension(arComprenhesionTemp)
        setCurrentDay(currentDayTemp)
    };

    const loadData = async () => {
        setOpenOpenLoader(true);
        const url = `/speed-reading/progress/${userId}`;
        const request = await HttpClient().get(url);

        setOpenOpenLoader(false);
        if (request.error) {
            showToast("No se pudo cargar información. Intenta nuevamente.", "error");
            return;
        }
        processDataProgress(request.data);
    };

    useEffect(() => {
        if (open) {
            loadData();
        }
    }, [open]);

    return (
        <Paper
            elevation={3}
            sx={{
                borderRadius: "12px",
                overflow: "hidden",
            }}
        >
            <OverlayLoader open={openLoader} />
            <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="tabs de seguimiento"
                        variant="fullWidth"
                        TabIndicatorProps={{
                            style: {
                                height: 4,
                            },
                        }}
                    >
                        <Tab
                            label="Seguimiento"
                            id="tab-0"
                            aria-controls="tabpanel-0"
                            sx={{
                                color: value === 0 ? "#f05a28" : "#9e9e9e",
                                fontWeight: value === 0 ? 600 : 400,
                            }}
                        />
                        <Tab
                            label="Velocidad"
                            id="tab-1"
                            aria-controls="tabpanel-1"
                            sx={{
                                color: value === 1 ? "#f05a28" : "#9e9e9e",
                                fontWeight: value === 1 ? 600 : 400,
                            }}
                        />
                        <Tab
                            label="Comprensión"
                            id="tab-2"
                            aria-controls="tabpanel-2"
                            sx={{
                                color: value === 2 ? "#f05a28" : "#9e9e9e",
                                fontWeight: value === 2 ? 600 : 400,
                            }}
                        />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <FollowUp rows={rowsTable} perfectWeeks={perfectWeeks} currentDay={currentDay} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Speed
                        key={"velocity"}
                        series={[
                            {
                                name: "Velocidad",
                                data: velocity,
                            },
                        ]}
                        footerText={"Evaluación/Test"}
                        leftText={"Palabras por minuto"}
                    />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <Speed
                        key={"comprenhesion"}
                        series={[
                            {
                                name: "Comprensión",
                                data: comprehension,
                            },
                        ]}
                        footerText={"Evaluación/Test"}
                        leftText={"Porcentaje"}
                        maxY={100}
                    />
                </TabPanel>
            </Box>
        </Paper>
    );
}

export default memo(ProgressModal);
